var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolBar"},[_c('operation-history'),_c('a-divider',{attrs:{"type":"vertical"}}),_c('node-attr'),_c('a-divider',{attrs:{"type":"vertical"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }